export default [
  {
    "id": "betonarna",
    "title": "betonarna",
    "image": "beton.jpg",
    "x": {
      "xl": 2,
      "lg": 2,
      "md": 1,
      "sm": 1,
      "xs": 0
    },
    "photos": 6,
    "y": {
      "xl": 0,
      "lg": 0
    },
    "fontSize": "1em",
    "charSpacing": 9,
    "speed": 0.1,
    "opacity": 1,
    "description": `<p>V sodobni betonarni Ammann s kapaciteto me&scaron;alnega bobna 2m3 vam zame&scaron;amo betonske me&scaron;anice vseh vrst, z možnostjo proizvodnje tudi v zimskem času (ogrevanje vode in agregatov).</p>
<p>Osnovne materiale predstavljajo prani prodnati agregati proizvedeni na lastni separaciji, cementi proizvajalca Salonit Anhovo in kemijski dodatki podjetja Master Builders. Kvaliteto betonskih me&scaron;anic stalno preverjamo v lastnem in pogodbenem laboratoriju.</p>
<p>Betoni so proizvedeni skladno s standardom SIST EN 206:2013 &nbsp;in SIST 1026:2016 in certificirani s strani certifikacijskega organa Igmat d.d.</p>
<ul class='icons'>
<li><a href='/static/pdf/beton_certifikat_o_skladnosti_tovarniske_kontrole_proizvodnje_igmat.pdf' target='_blank'><img src='/static/icons/pdf.svg'>Certifikat o skladnosti tovarniske kontrole proizvodnje</a></li>
<li><a href='/static/pdf/izjava_o_lastnostih_beton_zdruzenocompressed.pdf' target='_blank'><img src='/static/icons/pdf.svg'>Izjave o lastnostih - beton</a></li>
</ul>
<p>Nudimo prevoz betona z avto me&scaron;alci in kiper kamioni. Možen je tudi lasten prevzem na betonarni.</p>
<p>Kontaktirajte nas in svetovali vam bomo pri izbiri prave betonske me&scaron;anice, načinu dostave in vgradnje.</p>
<ul class='icons'><li><a href='/static/pdf/cenik_betonov_in_agregatov.pdf?v=currenttime'  class='cenik_link' target='_blank'> <img src='/static/icons/pdf.svg'>Cenik betonov, agregatov in prevozov</a></li></ul>`
  },
  {
    "id": "separacija",
    "title": "separacija",
    "image": "separacija.jpg",
    "x": {
      "xl": 0,
      "lg": 0,
      "md": 0,
      "sm": 0,
      "xs": 0
    },
    "photos": 8,
    "y": {
      "xl": 100,
      "lg": 50
    },
    "fontSize": "1em",
    "charSpacing": 9,
    "speed": 0.1,
    "opacity": 1,
    "description": `<p>Proizvodnja in prodaja visoko kvalitetnih pranih prodnatih agregatov, peskov, tampona, zemlje in savske mivke.</p>
<p>Obrat za predelavo savskega prodca je povsem nov, postavljen v letu 2017 in je trenutno eden izmed najsodobnej&scaron;ih načinov proizvodnje na trgu. Glavni del predstavlja pralnica in separacija Terex AggreSand, s katero pridelamo prane prodnate agregate frakcij: 0-4 mm, 4-8 mm, 8-16 mm, 16-32 mm in mleto frakcijo 0-4V .</p>
<p>Agregati so proizvedeni v skladu s standardom SIST EN 12620:2002+A1:2008 in certificirani s strani certifikacijskega organa Aktim d.o.o.</p>
<p>Z mobilno sejalnico Gipo in mobilnim drobilnikom Rockster proizvajamo tampone in grede različnih granulacij: 0-16 mm, 0-32 mm, 0-45 mm, 0-63 mm in 0-125 mm</p>
<p>Tamponi in greda so proizvedeni v skladu s standardom SIST EN 13242:2003+A1:2008 in certificirani s strani certifikacijskega organa Aktim d.o.o.</p>

<ul class='icons'><li><a href='/static/pdf/agregat_certifikat_o_skladnosti_tovarniske_kontrole_proizvodnje.pdf' target='_blank'><img src='/static/icons/pdf.svg'>Certifikat o skladnosti tovarniske kontrole proizvodnje </a></li>
<li><a href='/static/pdf/izjava_o_lastnostih_agregati_zdruzenocompressed.pdf' target='_blank'><img src='/static/icons/pdf.svg'>Izjave o lastnostih - pralni agregati</a></li>
<li><a href='/static/pdf/izjava_o_lastnostih_tamponi_zdruzeno_1compressed.pdf' target='_blank'><img src='/static/icons/pdf.svg'>Izjave o lastnostih - tamponi</a></li>
</ul>
<p>Nudimo prevoz večjih in manj&scaron;ih količin peska. Možen lasten prevzem.<br /> Več o na&scaron;i ponudbi je razvidno iz cenika.</p>
<ul class='icons'>  <li><a href='/static/pdf/cenik_betonov_in_agregatov.pdf?v=currenttime' class='cenik_link' target='_blank'><img src='/static/icons/pdf.svg'>Cenik betonov, agregatov in prevozov </a></li></ul>`
  },
  {
    "id": "transport",
    "title": "Transport",
    "image": "transport.jpg",
    "x": {
      "xl": 1,
      "lg": 1,
      "md": 0,
      "sm": 0,
      "xs": 0
    },
    "photos": 3,
    "y": {
      "xl": 200,
      "lg": 100
    },
    "fontSize": "0.8em",
    "charSpacing": 7,
    "speed": 0.1,
    "opacity": 1,
    "description": "<p>V sodelovanju z podjetjem AŽMAN d.o.o. vam poleg prevoza peska in betona nudimo tudi druge storitve na področju cestnega transporta:</p><ul><li>Kiper prevozi</li><li>Silos prevozi</li><li>Prevozi pakiranega, paletnega blaga</li><li>Izredni prevozi</li><li>Prevozi tovornih vozil, strojev in opreme</li><li>Prevozi nevarnih snovi - ADR</li><li>Zimska služba</li><li>Vzdrževanje vozil</li></ul><p><a href='http://www.azman.si/' target='_blank'><strong>http://www.azman.si/</strong></a></p>"
  },
  {
    "id": "tlaki",
    "title": "Industrijski tlaki, estrihi, strojni ometi",
    "image": "tlaki.jpg",
    "x": {
      "xl": 2,
      "lg": 2,
      "md": 1,
      "sm": 1,
      "xs": 0
    },
    "photos": 8,
    "y": {
      "xl": 470,
      "lg": 340
    },
    "fontSize": "0.75em",
    "charSpacing": 9,
    "speed": 0.1,
    "opacity": 1,
    "description": "<p>V sodelovanju z podjetjem Z&amp;O d.o.o. nudimo izvedbo zaključnih gradbenih del:</p><ul><li>Estrihi</li><li>Industrijski tlaki</li><li>Epoksi tlaki</li><li>Dekorativni betonski tlaki</li><li>Strojni ometi</li><li>Fasaderska dela</li></ul><p><a href='http://www.z-o.si/'  target='_blank'><strong>http://www.z-o.si/</strong></a></p>"
  },
  {
    "id": "deponiranje",
    "title": "Deponiranje in predelava gradbenih odpadkov",
    "image": "deponiranje.jpg",
    "x": {
      "xl": 0,
      "lg": 0,
      "md": 0,
      "sm": 0,
      "xs": 0
    },
    "photos": 3,
    "y": {
      "xl": 585,
      "lg": 445
    },
    "fontSize": "0.7em",
    "charSpacing": 3,
    "speed": 0.1,
    "opacity": 1,
    "description": `<p>Imamo pridobljeno okoljevarstveno dovoljenje za predelavo nenevarnih gradbenih odpadkov:</p>
<ul>
<li>17 01 01 - beton - sortiran brez drugih primesi</li>
<li>17 01 01 - armiran beton &ndash; brez drugih primesi</li>
<li>17 01 01 - armiran beton &ndash; potrebno pikiranje/razbijanje &ndash; brez drugih primesi razen železa</li>
<li>17 01 02 - opeka &ndash; sortirana brez drugih primesi</li>
<li>17 01 03 - plo&scaron;čice, keramika in stre&scaron;na opeka &ndash; sortirano brez drugih primesi</li>
<li>17 01 07 - me&scaron;anice betona, opeke, plo&scaron;čic in keramike, ki niso zajete v 17 01 06 &ndash; sortirano brez drugih primesi</li>
<li>17 03 02 - bitumenske me&scaron;anice, ki niso zajete v 17 03 01 &ndash; sortirano brez drugih primesi</li>
<li>17 05 04 - zemljina in kamenje, ki nista navedena pod 17 05 03</li>
<li>17 05 06 - izkopani material, ki ni naveden pod 17 05 05</li>
<li>17 05 08 - tolčenec izpod železni&scaron;kih tirov in pragov, ki ni naveden v 17 05 07</li>
<li>17 08 02 - gradbeni materiali na osnovi sadre, ki niso navedeni pod 17 08 01</li>
<li>17 09 04 - me&scaron;ani gradbeni odpadki in odpadki iz ru&scaron;enja objektov, ki niso navedeni pod 17 09 01, 17 09 02, 17 09 03, s primesmi do 10%</li>
</ul>
<p>Prevzem gradbenih odpadkov nudimo za vsa podjetja in fizične osebe. Možnost prevzema tudi z na&scaron;imi kiper kamioni na va&scaron;i lokaciji.</p>
<p>Za deponiranje vam izdamo evidenčni list, s katerim imate potrdilo, da ste pravilno ravnali z gradbenimi odpadki.</p>
<p>Cenik prevzema gradbenih odpadkov najdete na spodnji povezavi na strani 4.</p>
<ul class='icons'>  <li><a href='/static/pdf/cenik_betonov_in_agregatov.pdf?v=currenttime' class='cenik_link' target='_blank'><img src='/static/icons/pdf.svg'>Cenik betonov, agregatov in prevozov </a></li></ul>`
  },
  {
    "id": "izkopi",
    "title": "Izkopi, rušitve in zemeljska dela",
    "image": "izkopi.jpg",
    "x": {
      "xl": 1,
      "lg": 1,
      "md": 1,
      "sm": 1,
      "xs": 0
    },
    "photos": 6,
    "y": {
      "xl": 720,
      "lg": 550
    },
    "fontSize": "0.83em",
    "charSpacing": 3,
    "speed": 0.1,
    "opacity": 1,
    "description": `<p>V sodelovanju z podjetjem AŽMAN d.o.o. vam nudimo izkope ru&scaron;itve in zemeljska dela vseh vrst. Ponujamo tudi odvoz materiala na deponijo.</p>
<p>Kontakt:</p>
<ul>
<li>Klemen Ažman 041 444 440</li>
<li>Blaž Ažman 041 444 434</li>
</ul>`
  },
  {
    "id": "tehtanje",
    "title": "Tehtanje vozil",
    "image": "tehtanje.jpg",
    "x": {
      "xl": 2,
      "lg": 2,
      "md": 0,
      "sm": 0,
      "xs": 0
    },
    "photos": 3,
    "y": {
      "xl": 920,
      "lg": 680
    },
    "fontSize": "0.92em",
    "charSpacing": 9,
    "speed": 0.1,
    "opacity": 1,
    "description": "<p>Sodobna cestna tehtnica namenjena tehtanju vseh vrst tovornih vozil&nbsp; in drugih prevoznih sredstev.</p><ul><li>Natančnost +/- 20kg</li><li>Nosilnost 80t</li><li>Samopostrežni terminal</li><li>Izdaja tehtalnega lista</li></ul>"
  }
]



// WEBPACK FOOTER //
// ./src/components/Services/ServicesData.js